import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://svt-portal-production.up.railway.app/public';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getHeroes = async () => {
  const response = await api.get('/heroes');
  return response.data;
};

export const getHero = async (pageId) => {
  const response = await api.get(`/heroes/${pageId}`);
  return response.data;
};

export const getGallery = async (params = {}) => {
  const response = await api.get('/gallery', { params });
  return response.data;
};

export const getGalleryLabels = async () => {
  const response = await api.get('/gallery/labels');
  return response.data;
};

export const getProjects = async (params = {}) => {
  const response = await api.get('/projects', { params });
  return response.data;
};

export const getProject = async (slug) => {
  const response = await api.get(`/projects/${slug}`);
  return response.data;
};

export const getTestimonials = async (params = {}) => {
  const response = await api.get('/testimonials', { params });
  return response.data;
};

export const getServices = async () => {
  const response = await api.get('/services');
  return response.data;
};

export const getService = async (serviceKey) => {
  const response = await api.get(`/services/${serviceKey}`);
  return response.data;
};

export const getCompanyInfo = async () => {
  const response = await api.get('/company-info');
  return response.data;
};

export const submitContactForm = async (data) => {
  const response = await api.post('/contact', data);
  return response.data;
};

export default api;
